import { render, staticRenderFns } from "./FFormGroup.vue?vue&type=template&id=b90281b0&scoped=true"
import script from "./FFormGroup.vue?vue&type=script&lang=js"
export * from "./FFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90281b0",
  null
  
)

export default component.exports